const API_BASE = process.env.REACT_APP_API_URL;
const SEDE_DEP_API_URL = `${API_BASE}admin/sede-departamento`;

const getAuthHeaders = () => {
	const token = localStorage.getItem('authToken');
	const headers = {
		'Content-Type': 'application/json',
	};
	if (token) {
		headers['Authorization'] = `Bearer ${token}`;
	}
	return headers;
};

export async function getSedeDepartamentos() {
	const res = await fetch(SEDE_DEP_API_URL, {
		headers: getAuthHeaders()
	});
	return await res.json();
}

export async function createSedeDepartamento(values) {
	try {
		await fetch(SEDE_DEP_API_URL, {
			method: 'POST',
			headers: getAuthHeaders(),
			body: JSON.stringify({
				detaparametroId: Number(values.detaparametroId),
				nombre: values.nombre,
				valor: values.valor,
				descripcion: values.descripcion
			})
		});
		return true;
	} catch {
		return false;
	}
}

export async function editSedeDepartamento(idSede, detaparametroId, values) {
	try {
		await fetch(`${SEDE_DEP_API_URL}/${idSede}/${detaparametroId}`, {
			method: 'PUT',
			headers: getAuthHeaders(),
			body: JSON.stringify({
				nombre: values.nombre,
				valor: values.valor,
				descripcion: values.descripcion,
				estado: values.estado !== undefined ? Number(values.estado) : undefined
			})
		});
		return true;
	} catch {
		return false;
	}
}

export async function deleteSedeDepartamento(idSede, detaparametroId) {
	try {
		await fetch(`${SEDE_DEP_API_URL}/${idSede}/${detaparametroId}`, {
			method: 'DELETE',
			headers: getAuthHeaders()
		});
		return true;
	} catch {
		return false;
	}
}


// Obtener departamentos (servicios) por detaparametroId
export async function getDepartamentosPorDetaparametro(detaparametroId) {
	const url = `${SEDE_DEP_API_URL}/departamento/${detaparametroId}`;
	const res = await fetch(url, {
		headers: getAuthHeaders()
	});
	if (!res.ok) {
		throw new Error('No se pudo obtener los departamentos');
	}
	return await res.json();
}


